import React from 'react';
import {
    Box,
    Button,
    Container,
    Divider,
    Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container
            maxWidth="lg"
            sx={{
                minHeight: '100dvh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: {
                    xs: 2,
                    sm: 4,
                    md: 6,
                },
                py: {
                    xs: 4,
                    sm: 6,
                    md: 8,
                },
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 800,
                    textAlign: 'center',
                }}
            >   

                {/* 404 */}
                <Typography
                    sx={{
                        fontWeight: 700,
                        color: '#111827',
                        lineHeight: 1,
                        fontSize: {
                            xs: '3rem',
                            sm: '4rem',
                            md: '5rem',
                        },
                    }}
                >
                    404
                </Typography>

                {/* Heading */}
                <Typography
                    sx={{
                        fontWeight: 600,
                        color: '#111827',
                        mb: 2,
                        mt: 1,
                        fontSize: {
                            xs: '1.75rem',
                            sm: '2rem',
                            md: '2.5rem',
                        },
                    }}
                >
                    Page Not Found
                </Typography>

                {/* Description */}
                <Typography
                    sx={{
                        color: 'text.secondary',
                        maxWidth: 600,
                        mx: 'auto',
                        px: 2,
                        lineHeight: 1.6,
                        fontSize: {
                            xs: '1rem',
                            sm: '1.1rem',
                            md: '1.25rem',
                        },
                    }}
                >
                    The page you're looking for doesn't exist,
                    has been moved, or the URL is incorrect.
                </Typography>

                <Divider
                    sx={{
                        width: {
                            xs: '80%',
                            sm: 280,
                            md: 320,
                        },
                        mx: 'auto',
                        my: {
                            xs: 3,
                            md: 4,
                        },
                    }}
                />

                {/* Help Text */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        flexWrap: 'wrap',
                        color: 'text.secondary',
                        mb: {
                            xs: 4,
                            md: 5,
                        },
                        px: 2,
                    }}
                >
                    <HelpOutlineIcon fontSize="small" />
                    <Typography
                        sx={{
                            textAlign: 'center',
                            fontSize: {
                                xs: '0.9rem',
                                md: '1rem',
                            },
                        }}
                    >
                        Check the URL or return to the homepage.
                    </Typography>
                </Box>

                {/* Buttons */}
                 <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: { xs: 1.5, sm: 2 },
                            flexDirection: {
                              xs: 'column',
                              sm: 'row',
                            },
                            alignItems: 'center',
                          }}
                        >
                          <Button
                            variant="contained"
                            size="large"
                            onClick={() => navigate('/dashboard')}
                            sx={{
                              width: {
                                xs: '100%',
                                sm: 'auto',
                              },
                              maxWidth: { xs: '100%', sm: 280, md: 300 },
                              minWidth: { sm: 160, md: 180 },
                              py: { xs: 1.25, sm: 1.5 },
                              px: { xs: 3, sm: 4 },
                              borderRadius: 2,
                              textTransform: 'none',
                              fontSize: { xs: '0.9rem', sm: '1rem' },
                              boxShadow: 'none',
                              '&:hover': {
                                backgroundColor: 'rgba(150, 193, 33, 0.75)',
                                color: '#fff',
                              },
                            }}
                          >
                            Back to Home
                          </Button>
                 
                          <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate(-1)}
                            sx={{
                              width: {
                                xs: '100%',
                                sm: 'auto',
                              },
                              maxWidth: { xs: '100%', sm: 280, md: 300 },
                              minWidth: { sm: 160, md: 180 },
                              py: { xs: 1.25, sm: 1.5 },
                              px: { xs: 3, sm: 4 },
                              borderRadius: 2,
                              textTransform: 'none',
                              fontSize: { xs: '0.9rem', sm: '1rem' },
                            }}
                          >
                            Go Back
                          </Button>
                        </Box>
            </Box>
        </Container>
    );
};

export default NotFound;